
'use client';

import { Product, Category, StoreSettings, AppearanceSettings, DeliverySettings } from '@/lib/types';
import { HomePageContent } from './HomePageContent';
import AgeGate from '@/components/shared/AgeGate';
import FreeSpinPopup from '@/components/shared/FreeSpinPopup';

interface HomePageClientProps {
  products: Product[];
  categories: Category[];
  storeSettings: StoreSettings | null;
  appearanceSettings: AppearanceSettings | null;
  deliverySettings: DeliverySettings | null;
  error?: string | null;
}

export default function HomePageClient(props: HomePageClientProps) {
  return (
    <>
      <AgeGate />
      <FreeSpinPopup />
      <HomePageContent
        products={props.products}
        categories={props.categories}
        storeSettings={props.storeSettings}
        appearanceSettings={props.appearanceSettings}
        deliverySettings={props.deliverySettings}
        error={props.error || null}
      />
    </>
  );
}
